import {
  mockCart,
  mockCartParcel,
  mockCartOrderSummary,
} from "../cart/mockCart";

export const generateRemoveItemMock = ({ id }) => {
  const updatedParcels = mockCartParcel.map((parcel) => ({
    ...parcel,
    items: parcel.items.filter((item) => item.id !== id),
  }));

  const updatedItems = updatedParcels.flatMap((parcel) => parcel.items);

  const updatedTotal = {
    amount: updatedItems.reduce((acc, item) => acc + item.totalPrice.amount, 0),
    currency: "AUD",
  };

  return {
    ...mockCart,
    parcels: updatedParcels,
    orderSummary: {
      ...mockCartOrderSummary,
      itemSummary: {
        items: updatedItems,
        total: updatedTotal,
      },
    },
    subtotalPrice: updatedTotal,
    totalPrice: updatedTotal,
  };
};
